<!--
  GridWidget.vue

  그리드 레이아웃에서 사용하는 아이템 컴포넌트

  NGF 1.2.0 수정 이력

  1) 리사이즈 관련 이벤트 제거
-->

<template>
  <div class="grid-stack-item"
       :id="i"
       :style="widgetExpandStyle"
       :data-gs-s="s"
       :data-gs-x="x"
       :data-gs-y="y"
       :data-gs-n="n"
       :data-gs-width="w"
       :data-gs-height="h"
       :data-gs-locked="isLock"
       :data-gs-no-move="!isMove"
       :data-gs-no-resize="!isResize"
       :data-gs-auto-position="autoPosition"
  >
    <div class="grid-stack-item-content">
      <div class="bs grid-stack-item-title grid-stack-movehandle grid-stack-submenu">
        <!-- 타이틀 시작 -->
        <div ref="titleContainer"
             class="page-title-1depth grid-stack-item-title-container grid-stack-space1"
        >
          <!-- 타이틀 문자열 -->
          <span class="page-title-1depth-text" style="flex: 1;margin-right:7px;">{{ `${$t(`dash.${title}`)} ${(n === '' || Number(n) === 0) ? '' : `(${n})`}` }}</span>
          <tool-tip>
            <div style="display: flex; align-items: center;">
              <span style="margin-right: 5px;">{{ $t(`dash.${title}`) }}</span>
              <template v-for="{label, css, style, value} in displayType">
               <span :key="value" :class="['size-md', css]" :style="`${style}`">{{label}}</span>
              </template>
            </div>
          </tool-tip> <!-- TAMS -->
          <!-- 대상 장비 타입 표시 -->
          <template v-for="{label, css, style, value} in displayType">
             <span :key="value" :class="['size-md', css]" :style="`${style}`">{{label}}</span>
          </template>
        </div>

        <!-- Flex 공간 -->
        <div class="grid-stack-space2">
          <div style="width: 30px">
            <!-- 스피너 -->
            <q-spinner class="grid-stack-item-spinner" v-show="showProgress"/>
          </div>
        </div>

        <!-- 상위 옵션 시작 -->
        <div ref="optionsGroup"
             class="page-contents-option-group grid-stack-item-options grid-stack-space3"
             style="-ms-grid-column: 3;"
        >
          <!-- 상위 데이터 테이블 옵션 시작 -->
          <div class="page-contents-btn-group-last">
            <!-- IP 예외 필터 버튼 영역 -->
            <q-btn v-if="enableIpFilter"
                   @click="onIpFilter"
                   flat
                   color="dark"
                   class="bs bs-q-btn-sm bs-q-btn-flat-type">
              <q-icon :class="['bs-q-btn-icon', `bs-q-btn-ip-filter-dashboard${isSelectedIpFilter ? '-r' : ''}`]"/>
            </q-btn>
            <!-- 장비 필터 버튼 영역 -->
            <q-btn v-if="enableDeviceFilter"
                   @click="onDeviceFilter"
                   flat
                   color="dark"
                   class="bs bs-q-btn-sm bs-q-btn-flat-type">
              <q-icon :class="['bs-q-btn-icon', `bs-q-btn-filter-dashboard${isSelectedMachId ? '-r' : ''}`]"/>
            </q-btn>

            <!-- VLAN 트래픽 추이만 해당됨 : VLAN ID 선택 -->
            <q-btn v-if="enableVlanType"
                   size="sm"
                   :label="selectedVlanText"
                   @click="onClickVlanInput"
                   outline="outline"
                   class="bs bs-q-btn-xs bs-q-btn-line text-primary marT4"/>

            <!-- IPv4/IPv6 버전 선택 필터 -->
            <q-dropdown-select v-if="enableIpType"
                               v-model="selectedIpType"
                               :options="ipTypeList"
                               :icon-class="ipTypeStyle"
                               @change="onChangeWidgetIpType"
            />

            <!-- HA Member 선택 -->
            <q-dropdown-select v-if="enableHaDev"
                               v-model="selectedHaMember"
                               :options="selectHaOptions"
                               :icon-class="haDevStyle"
                               @change="onChangeWidgetHaMember"
            />

            <!-- 차트 타입 변경 메뉴 -->
            <q-select v-if="widgetChartMenu.length"
                      v-model="chartType"
                      size="sm"
                      flat="flat"
                      class="bs bs-q-sm bs-q-select bs-q-select-default icon-chart-box"
                      :popover-class="'dashboard-icon-wrap'"
                      :options="widgetChartMenu"
                      :ha-force="true"
                      :auth-force="true"
                      @input="onInputChartType"
            />
            <!--            <q-btn-dropdown v-if="widgetChartMenu.length > 0"-->
            <!--                            size="md"-->
            <!--                            flat="flat"-->
            <!--                            class="bs bs-q-btn-dropdown-md bs-q-btn-dropdown-flat-type bs-q-btn-flat-ico-chart"-->
            <!--                            :auth-force="true"-->
            <!--            >-->
            <!--              <grid-widget-menu :widget-chart-menu="widgetChartMenu"/>-->
            <!--            </q-btn-dropdown>-->

            <!-- 위젯 기본 메뉴 -->
            <q-btn-dropdown size="md"
                            flat="flat"
                            class="bs bs-q-btn-dropdown-md bs-q-btn-dropdown-flat-type bs-q-btn-flat-ico-more"
                            :ha-force="true"
                            :auth-force="true"
            >
              <grid-widget-menu :widget-basic-menu="widgetBasicMenu"
                                :widget-custom-menu="widgetCustomMenu"
              />
            </q-btn-dropdown>
          </div>
          <!-- 상위 데이터테이블 옵션 끝 -->
        </div>
      </div>

      <!-- 실제 위젯 컨텐츠 시작 -->
      <div class="grid-stack-item-slot"
           :style="widgetExpandSlotStyle"
      >
        <component ref="widgetContext"
                   :is="internalComponent"
                   :i="i"
                   :uuid="uuid"
                   :parent="self"
                   :vlan-opt="targetVlan"
                   :ip-type-opt="searchIpType"
                   :device-type-opt="deviceType"
                   :init-options="opts"
                   :ha-member-opt="targetHaMember"
                   @showProgress="value => showProgress = value"
                   @removeWidget="onRemoveWidget"
                   @expandButton="onShowExpandButton"
                   @maximumWidget="onShowMaximumWidget"
                   @changeVlanId="setSelectVlanId"
        />
      </div>
    </div>

    <!--TAMS-->
    <device-dialog ref="deviceDialog"
                   multiple
                   disable-search-device-type
                   :only-group-yn="false"
                   :only-config-yn="false"
                   :tams-yn="false"
                   :slave-yn="true"
                   :except-mon-node-yn="false"
                   is-synced
                   :synced.sync="isSyncFilterDevice"
                   :syncedData="syncFilterDeviceData"
                   @confirm="onChangeWidgetMachId"/>
    <filter-exp-ip-dialog ref="ipExpDialog"
                          :notVisible="false"
                          @save="onChangeIpFilter"
    />
  </div>
</template>
<script>
  // 공통 유틸모듈
  import * as Utils from './utils'
  import commonValueMixin from '~/mixins/value/commonValueMixin'

  import { getFilterDeviceData } from '~/utils/dashboard'
  // 드롭다운 셀릭트 컴포넌트
  import QDropdownSelect from '~/components/control/QDropdownSelect'
  import DeviceDialog from '~/components/pageComponents/common/filterDeviceDialog'
  import FilterExpIpDialog from '~/components/pageComponents/dashboard/filter/filterExpIpDialog' // TAMS

  export default {
    name: 'GridWidget',
    components: {
      FilterExpIpDialog,
      QDropdownSelect,
      DeviceDialog
    },
    directives: {},
    mixins: [commonValueMixin],
    props: {
      x: {
        type: [Number, String],
        default: 0
      },
      y: {
        type: [Number, String],
        default: 0
      },
      w: {
        type: [Number, String],
        default: 1,
        validator (width) {
          return width > 0 && width < 4
        }
      },
      h: {
        type: [Number, String],
        default: 1,
        validator () {
          return 1
        }
      },
      i: {
        type: String,
        required: true
      },
      s: {
        type: [Number, String],
        required: true
      },
      n: {
        type: [Number, String],
        default: ''
      },
      uuid: {
        type: String,
        default: ''
      },
      opts: {
        type: Object,
        default: () => {}
      },
      title: String,
      isVlan: {
        type: [Boolean, String],
        default: false
      },
      isLock: {
        type: [Boolean, String],
        default: false
      },
      isMove: {
        type: [Boolean, String],
        default: true
      },
      isResize: {
        type: [Boolean, String],
        default: true
      },
      contents: {
        type: String,
        default: ''
      },
      haMembers: {
        type: Array,
        default: () => []
      },
      autoPosition: {
        type: Boolean,
        default: true
      },
      layoutInstance: {
        default: () => null
      },
      onRefreshWidget: {
        type: Function,
        default: () => function () {}
      },
      onLoadInternalComponent: {
        type: Function,
        default: () => function () {}
      },
      onResizeStartHandler: {
        type: [Object, Function],
        default: () => null
      },
      onResizeStopHandler: {
        type: [Object, Function],
        default: () => null
      }
    },
    data () {
      return {
        self: this,
        lazyLoad: false,
        chartType: '',
        deviceType: [], // 지원 장비 타입(20: NGF, 21: IPS), default: 빈 배열(TAMS)
        selectedVlan: -1,
        selectedIpType: 'v46',
        widgetStyle: {},
        enableHaDev: false,
        enableIpType: false,
        enableVlanType: false,
        isSelectedMachId: false,
        isSyncFilterDevice: true,
        // machId: [],
        deviceFileterKey: '', // 'device_uname', // 'device_id',
        enableDeviceFilter: true,
        // IP 예외 필터
        enableIpFilter: false,
        isSelectedIpFilter: false,

        showProgress: false,
        widgetSlotStyle: {},
        widgetBasicMenu: [],
        widgetChartMenu: [],
        widgetCustomMenu: [],
        selectHaOptions: [],
        selectedHaMember: '',
        widgetContentsHeight: 0
      }
    },
    computed: {
      filterDevice () {
        return this.$parent.$parent.filterDevice
      },
      /**
       * 이름: syncFilterDeviceData
       * 설명: 대상 장비 필터 동기화시 전달할 Device ID or Name 파라미터.
       */
      syncFilterDeviceData () {
        return _.isEmpty(this.deviceFileterKey) ?
            this.filterDevice :
            _.map(this.filterDevice, this.deviceFileterKey)
      },
      /**
       * 이름: targetVlan
       * 설명: VLAN 트래픽 추이 위젯에서 VLAN ID를 전달하는 파라미터.
       */
      targetVlan () {
        return this.enableVlanType ? this.selectedVlan : void 0
      },
      selectedVlanText () {
        // return this.selectedVlan === -1 ? 'TOTAL' : `VLAN ID ${this.selectedVlan}`
        return this.selectedVlan > 0 ? `VLAN ID ${this.selectedVlan}` : 'TOTAL'
      },
      haDevStyle () {
        // 모든 HA 장비의 정보를 선택한 경우
        if (this.selectedHaMember === 'hagroup') {
          return 'bs-q-btn-flat-ico-ha-all'
        }

        // HA 장비의 UUID가 있는 경우
        if (this.selectedHaMember) {
          // HA 장비 정보 가져오기
          const targetDev = this.haMembers.filter((member) => member.mmbr_uuid === this.selectedHaMember)[0] || {}

          // Role이 마스터인지 확인
          return targetDev.role === 'master' ? 'bs-q-btn-flat-ico-ha-master' : targetDev.role === 'slave' ? 'bs-q-btn-flat-ico-ha-slave' : ''
        }

        // HA 정보가 없으면 ''
        return ''
      },
      ipTypeStyle () {
        // V4 / V6 모두를 선택한 경우
        switch (this.selectedIpType) {
          case 'v46':
            return 'bs-q-btn-flat-ico-iptype-all'
          case 'v4':
            return 'bs-q-btn-flat-ico-iptype-v4'
          case 'v6':
            return 'bs-q-btn-flat-ico-iptype-v6'
          default:
            return ''
        }
      },
      /**
       * 이름: displayType
       * 설명: 지원 장비 리스트
       */
      displayType () {
        return _.filter(this.deviceTypeList, (dt) => _.includes(this.deviceType, dt.value))
      },
      searchIpType () {
        return this.enableIpType ? this.selectedIpType : ''
      },
      targetHaMember () {
        return this.haMembers.length > 0 ? this.selectedHaMember : ''
      },
      internalComponent () {
        return this.onLoadInternalComponent(this.contents)
      },
      widgetExpandStyle: {
        get () {
          return this.widgetStyle
        },
        set (style) {
          this.widgetStyle = style
        }
      },
      widgetExpandSlotStyle: {
        get () {
          return this.widgetSlotStyle
        },
        set (style) {
          this.widgetSlotStyle = style
        }
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    methods: {
      /**
       * 이름: onDeviceFilter
       * 설명: 장비 트리 팝업 Open
       */
      onDeviceFilter () {
        // 위젯 별 장비 사용 여부에 따라 전역 필터 사용 여부 적용 후 opts.mach_id 값을 넘김.
        this.isSyncFilterDevice = !this.isSelectedMachId
        this.$nextTick(() => {
          this.$refs.deviceDialog.show({ selectedItem: this.isSelectedMachId ? this.opts.mach_id : [] })
        })
      },
      /**
        이름: onChangeWidgetMachId
        설명: Device Tree 선택 시 위젯 데이터를 다시 불러온다.
      */
      onChangeWidgetMachId ({ selectedItem, notChecked }) {
        this.isSelectedMachId = !this.isSyncFilterDevice && !_.isEmpty(selectedItem)
        const machId = this.isSelectedMachId ? getFilterDeviceData(selectedItem) : []
        // 위젯 옵션 변경
        this.setSelectMachId(machId)

        // 위젯 데이터 재조회
        this.$refs.widgetContext.onChangeWidgetMachId({ machId })
      },
      /**
       * 이름: onSelectMachId
       * 설명: 장비 필터의 확인시 하위 컴포넌트에 선택한 장비 변경을 수행한다.
       */
      setSelectMachId (machId = []) {
        // 위젯 장비 필터 리스트 변경 요청
        this.setMachId(machId)

        // 위젯 콘텐츠 객체 가져오기
        const widgetContext = this.$refs.widgetContext || null

        // 위젯 콘텐츠 객체가 없으면 리턴
        if (!widgetContext) {
          return
        }

        // 위젯 장비 필터 리스트 변경 요청
        widgetContext.onChangeMachId(machId)
      },
      /**
       * 이름: setMachId
       * 설명: 위젯 장비 필터 리스트 설정
       */
      setMachId (machId = []) {
        this.opts.mach_id = machId
        // this.machId = machId
      },
      /**
       * 이름: onIpFilter
       * 설명: 위젯 IP 예외 필터 리스트 설정
      */
      onIpFilter () {
        const confirmBtnDisable = true
        this.$refs.ipExpDialog.show({
          name: this.$t('dash.filterExpIpList'),
          filter: this.isSelectedIpFilter ? this.opts.ip_exp_list : []
        }, confirmBtnDisable)
      },
      /**
       * 이름: onChangeIpFilter
       * 설명: 위젯 IP 예외 필터 팝업 저장 이벤트 리스너
      */
      onChangeIpFilter ({filter}) {
        this.isSelectedIpFilter = _.size(filter) > 0
        this.setIpFilter(filter)
        this.$refs.widgetContext.onChangeIpFilter({filter})
      },
      /**
       * 이름: setIpFilter
       * 설명: 위젯 IP 예외 필터 리스트 설정
      */
      setIpFilter (ipExpList = []) {
        this.opts.ip_exp_list = ipExpList
      },

      /**
       * 이름: setDeviceType
       * 설명: 장비 타입 설정 [지원 장비 타입(20: NGF, 21: IPS), default: 빈 배열(TAMS)]
       */
      setDeviceType (deviceType = void 0) {
        this.deviceType = _.isNil(deviceType) ? [] : deviceType
      },
      /**
       * 이름: setSelectVlanId
       * 설명: VLAN 추이 차트에서 조회한 VLAN ID를 void 0 으로 초기화한다.
       */
      setSelectVlanId (vlanId = void 0) {
        this.selectedVlan = _.isNil(vlanId) ? void 0 : vlanId
      },
      /**
       * 이름: setChartType
       * 설명: 차트 타입을 선택할 수 있는 경우, 위젯 컨텐츠에 저장된 값으로 초기화한다.
       */
      setChartType (chartType) {
        this.chartType = chartType
      },
      /**
       * 이름: setSelectIpType
       * 설명: IP 타입을 선택할 수 있는 경우, 이전에 저장된 IP 값으로 초기화한다.
       */
      setSelectIpType () {
        this.selectedIpType = this.opts.ipType ? this.opts.ipType : 'v46'
      },
      /**
        이름: setSelectHaMembers
        설명: 위젯 컨텍스트가 마운트되면, HA 멤버 리스트를 설정한다.
      */
      setSelectHaMembers (haType) {
        // HA Member 정보 추가
        let haMemberOptions = []

        // 현재 위젯의 HA 타입이 'all' 이라면 옵션에 '전체' 추가
        if (haType === 'all') {
          haMemberOptions.push({
            raw: null,
            type: 'hagroup',
            icon: 'bs-q-btn-flat-ico-ha-all',
            label: this.$t('cmn.all'),
            value: 'hagroup'
          })
        }

        // HA 멤버 입력
        for (const member of this.haMembers) {
          haMemberOptions.push({
            raw: member,
            type: 'local',
            icon: member.role === 'master' ? 'bs-q-btn-flat-ico-ha-master' : 'bs-q-btn-flat-ico-ha-slave',
            label: `${member.mmbr_name} (${member.ip})`,
            value: member.mmbr_uuid
          })
        }

        // 이전에 저장된 HA Member가 있는 경우
        if (this.opts.haMember) {
          // 이전에 저장된 HA Member가 HA 멤버 리스트에 있으면 선택
          const checkHaMember = this.haMembers.filter((member) => member.mmbr_uuid === this.opts.haMember) || ''

          if (checkHaMember.length > 0) {
            this.selectedHaMember = this.opts.haMember
          } else {
            this.selectedHaMember = haMemberOptions[0].value
          }
        } else {
          this.selectedHaMember = haMemberOptions[0].value
        }

        // 옵션 선택
        this.selectHaOptions = haMemberOptions

        // HA 버튼 활성화
        this.enableHaDev = true
      },
      /**
       * 이름: setDeviceToUuid
       * 설명: 전달된 UUID에 해당하는 장비를 선택한다.
       */
      setDeviceToUuid (uuid) {
        if (this.selectHaOptions.length > 0) {
          const targetDevice = this.selectHaOptions.filter((member) => member.value === uuid)

          if (targetDevice.length > 0) {
            this.selectedHaMember = targetDevice[0].value
          }
        }
      },
      /*
        이름: setTitleContainerWidth
        설명: 타이틀 컨테이너 너비를 설정한다. Release 파라미터가 있는 경우, maxWidth를 제거한다.
      */
      setTitleContainerWidth () {
        // // 위젯 서브 메뉴 + 스피너 너비
        // let totalOptionWidth = 83
        //
        // // 현재 위젯 너비
        // const widgetWidth = this.$el.clientWidth
        //
        // // 위젯 타이틀 너비
        // const titleDom = this.$refs.titleContainer
        //
        // // IP 타입이 있는 경우
        // if (this.enableIpType) {
        //   totalOptionWidth += 34
        // }
        //
        // // HA 멤버가 있는 경우
        // if (this.haMembers.length > 0) {
        //   totalOptionWidth += 34
        // }
        //
        // // ChartType이 있는 경우
        // if (this.widgetChartMenu.length > 0) {
        //   totalOptionWidth += 34
        // }
        //
        // // 위젯 너비를 헤더 옵션이 넘어서는 경우 28% 크기로 헤더 타이틀 크기 제한
        // if (widgetWidth * 0.5 <= totalOptionWidth) {
        //   titleDom.style.maxWidth = `28%`
        // } else {
        //   titleDom.style.maxWidth = 'calc(50% - 32px)'
        // }
      },
      /*
        이름 : setWidgetHeaderOptions
        설명 : 현재 위젯의 서브 메뉴를 설정한다.
              위젯 헤더 옵션의 경우, 위젯마다 모두 다르고 상위 컴포넌트에서 초기화 하므로 유지보수 시 컨텐츠 래퍼에서 찾지말자.
        파라미터
          - haType: 전체, HA Member 초기화
          - ipType: IP 타입을 선택 가능할 경우
          - isVlan: VLAN 트래픽 추이 차트만 해당됨
          - deviceType:  지원 장비 타입, default: 빈 배열(TAMS)
                         ex) [20, 21]/[NGF][IPS], [20]/[NGF], [21]/[IPS], default/[]
          - isDeviceFilter: 위젯별 장비 필터 팝업 Open.
          - isIpFilter: 위젯별 예외 IP 필터 팝업 Open
          - basicMenu : 위젯 삭제, 최대화, 새로고침
          - chartMenu : 차트 변환이 지원될 경우 차트 종류를 변경
          - customMenu : 대상 위젯만의 특수한 메뉴
      */
      setWidgetHeaderOptions ({ haType, ipType, isVlan, deviceType = [], isDeviceFilter = true, isIpFilter = false}, basicMenu, chartMenu, customMenu) {
        return new Promise((resolve, reject) => {
          try {
            // 위젯 기본, 차트, 커스텀 메뉴 설정
            this.widgetBasicMenu = basicMenu || []
            this.widgetChartMenu = chartMenu || []
            this.widgetCustomMenu = customMenu || []
            // VLAN 트래픽 추이만 해당됨
            this.enableVlanType = isVlan || false
            // VLAN ID 설정.
            if (this.enableVlanType) {
              this.setSelectVlanId(this.opts.vlanId)
            }

            // IP Type 조회 기능 활성화 / 비활성화
            this.enableIpType = ipType || false
            // IP Type 선택
            if (this.enableIpType) {
              this.setSelectIpType()
            }

            // HA 멤버 설정
            if (this.haMembers.length > 0) {
              this.setSelectHaMembers(haType)
            }

            // 지원 장비 표시(20: NGF, 21: IPS), default: 빈 배열(TAMS)
            if (!_.isEmpty(deviceType)) {
              this.setDeviceType(deviceType)
            }

            // 장비 Filter
            this.enableDeviceFilter = isDeviceFilter
            if (this.enableDeviceFilter) {
              // 초기값 설정
              this.setMachId()
            }

            // IP Filter
            this.enableIpFilter = isIpFilter || false
            // IP 필터 선택
            if (this.enableIpFilter) {
              // IP 필터 기능
              this.isSelectedIpFilter = this.opts.ip_exp_list.length > 0
            }

            // Resolve 실행
            resolve()
          } catch (e) {
            reject(e)
          }
        })
      },
      /**
       * 이름: onInputChartType
       * 설명: 차트 타입이 변경되면 하위 컴포넌트에 차트 타입 변경을 수행한다.
       */
      onInputChartType (chartType) {
        // 위젯 내부 차트 타입 모델 변경
        this.chartType = chartType

        // 위젯 콘텐츠 객체 가져오기
        const widgetContext = this.$refs.widgetContext || null

        // 위젯 콘텐츠 객체가 없으면 리턴
        if (!widgetContext) {
          return
        }

        // 위젯 차트 변경 요청
        if (chartType === 'pie') {
          widgetContext.onChangePieChart()
        } else if (chartType === 'bar') {
          widgetContext.onChangeBarChart()
        } else if (chartType === 'column') {
          widgetContext.onChangeColumnChart()
        } else if (chartType === 'treemap') {
          widgetContext.onChangeTreeMapChart()
        } else if (chartType === 'sunburst') {
          widgetContext.onChangeSunburst()
        }
      },
      /*
        이름 : onShowExpandButton
        설명 : 내부 컨텐츠가 위젯의 높이보다 크면 확장 버튼을 화면에 출력한다.
        파라미터
          - wrapperHeight: 위젯 내부 컨텐츠의 래퍼 Div의 높이
          - contentsHeight : 위젯 내부 실제 컨텐츠 높이
      */
      onShowExpandButton (wrapperHeight, contentsHeight) {
        this.widgetContentsHeight = contentsHeight
        if (wrapperHeight - 50 < contentsHeight) {
          // 버튼 화면에 출력
          this.showExpandBtn = true
        } else {
          this.showExpandBtn = false
        }
      },
      /*
        이름 : onClickLockedWidget
        설명 : 대상 위젯을 잠금 처리한다.
      */
      onClickLockedWidget () {
        // 잠금여부 처리
        Utils.lockWidget(this.layoutInstance, this.$el, this.$el.getAttribute('data-gs-locked') === 'yes' ? false : true)
      },
      /*
        이름 : onRemoveWidget
        설명 : 대상 위젯을 제거하는 이벤트를 호출한다. 그리드 레이아웃에서 처리한다.
      */
      onRemoveWidget () {
        // Gridstack의 Widget 제거
        Utils.removeWidget(this.layoutInstance, this.$el)

        // Remove Target Widget 이벤트 호출
        this.$emit('removeTargetWidget', this.i)
      },
      /*
        이름 : onShowMaximumWidget
        설명 : 대상 위젯의 컨텐츠 영역을 최대화 팝업으로 화면에 출력한다.
      */
      onShowMaximumWidget () {
        // 현재 차트에 등록되어있는 데이터 셋팅
        const innerContents = this.$refs.widgetContext

        // 위젯을 최대 사이즈의 팝업으로 출력
        this.$emit('openMaximumWidget', this.title, this.i, this.n, innerContents)
      },
      /**
       * 이름: onClickVlanInput
       * 설명: 트래픽 추이를 출력할 VLAN 선택창 호출 한다.
       */
      onClickVlanInput () {
        this.$refs.widgetContext.onShowVlanPopUp()
      },
      /**
        이름: onChangeWidgetIpType
        설명: IP Type 변경 시 위젯 데이터를 다시 불러온다.
      */
      onChangeWidgetIpType (ipType) {
        this.$refs.widgetContext.getWidgetContentsData(true, {ipType})
      },
      /*
        이름: onChangeWidgetHaMember
        설명:
      */
      onChangeWidgetHaMember (haMember) {
        this.$refs.widgetContext.getWidgetContentsData(true, {haMember})
      },
    },
    watch: {
      isMove (value) {
        Utils.movableWidget(this.layoutInstance, this.$el, value)
      },
      isLock (value) {
        Utils.lockWidget(this.layoutInstance, this.$el, value)
      },
      isResize (value) {
        Utils.resizableWidget(this.layoutInstance, this.$el, value)
      }
    }
  }
</script>

<style scoped>
  .page-title-1depth {
    overflow: hidden;
    align-self: center;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .grid-stack-item-title {
    display: -ms-grid;
    display: inline-grid;
    grid-template-columns: auto 1fr max-content;
    -ms-grid-columns: 1fr minmax(0px, 0px) max-content;
  }

  .grid-stack-item-options {
    justify-self: end;
  }

  .grid-stack-space1 {
    -ms-grid-column: 1;
  }

  .grid-stack-space2 {
    -ms-grid-column: 2;
  }

  .grid-stack-space3 {
    -ms-grid-column: 3;
  }

  .grid-stack-item-spinner {
    width: 20px;
    color: #509ae0;
    height: 20px;
    align-self: center;
    justify-self: start;
  }

  /*.bs-q-btn-vlan {*/
  /*  filter: none;*/
  /*  margin-top: 2px;*/
  /*  background: #498dda!important;*/
  /*  color: #fff!important;*/
  /*  border: 1px solid #66a0e0 !important;*/
  /*  text-align: center!important;*/
  /*}*/
</style>
